// src/utils/apiClient.js
import { getToken } from "./cryptoUtils";
import { triggerSessionExpired } from "./sessionEvents";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiClient = async (endpoint, options = {}) => {
  const token = getToken();

  // ✅ Detect FormData
  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(!isFormData && { "Content-Type": "application/json" }),
    ...options.headers,
  };

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  // 🔐 Session expired
  if (response.status === 401) {
    triggerSessionExpired();
    throw { detail: "Session expired" };
  }

  const text = await response.text();
  let data = null;

  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { detail: text };
  }

  // ❌ Throw error for non-2xx
  if (!response.ok) {
    throw data;
  }

  return data;
};

export default apiClient;
